import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Divider } from 'components/HeroSemantic';

export default class Footer extends Component {
  render() {
    return (
      <footer style={{ color: 'var(--owner-text-muted)', fontSize: '13px', lineHeight: '20px', padding: '10px 16px', textAlign: 'center', width: '100%' }}>
        <div style={{ margin: '0 auto', maxWidth: 'var(--tenant-max-width, 1200px)', width: '100%' }}>
          <Divider />
          <span>
            <FormattedMessage id="footer.message" />
          </span>
        </div>
      </footer>
    );
  }
}
